define('shared/initializer/form/adapters/mixins/AdyenReturnable',[
    '$',
    'shared/remote/payment/adyen/payWithToken',
    'shared/util/state',
    'shared/initializer/form/constants',
    'Promise',
    './AdyenSwitchable',
    'shared/util/adyen/rejectWithOrderCreationFailed',
],
function (
    $,
    payWithToken,
    state,
    constants,
    Promise,
    AdyenSwitchable,
    rejectWithOrderCreationFailed
) {
    'use strict';

    var ORDERED = 'Ordered';

    function payWithStoredMethod () {
        var offers;
        return state.retrieve(constants.State.OrderOfferId)
            .then(function(value){
                offers = value;
                if (!offers || offers.length <= 0) {
                   return Promise.reject('No offer id specified');
                }
            })
            .then(function(){
                return payWithToken(offers);
            })
            .then(null, function() {
                return rejectWithOrderCreationFailed();
            })
            .then(function(res) {
                if (res && res.orderStatus) {
                    if (res.orderStatus === ORDERED) {
                        res.Id = res.orderId;
                        delete res.orderId;
                        return Promise.resolve(res);
                    }
                    return rejectWithOrderCreationFailed();
                    
                }
            });
    }

    function Ctor() {}

    Ctor.prototype.doPageLoad = function() {
        var form = this;

        var subEls = AdyenSwitchable.getSubElements(form);
        subEls.storedPayment.$submit
            .on('click', function(evt){
                evt.preventDefault();
                form.emit('payment.start');
            });
        
    };

    Ctor.prototype.doSubmit = function() {
        return payWithStoredMethod();
    };

    return Ctor;
    
});
